__turbopack_context__.v({
  "flex_1": "Tiles-module-scss-module__o95yIq__flex_1",
  "flex_2": "Tiles-module-scss-module__o95yIq__flex_2",
  "flex_3": "Tiles-module-scss-module__o95yIq__flex_3",
  "flex_4": "Tiles-module-scss-module__o95yIq__flex_4",
  "flex_5": "Tiles-module-scss-module__o95yIq__flex_5",
  "flex_6": "Tiles-module-scss-module__o95yIq__flex_6",
  "flex_desktop_1": "Tiles-module-scss-module__o95yIq__flex_desktop_1",
  "flex_desktop_2": "Tiles-module-scss-module__o95yIq__flex_desktop_2",
  "flex_desktop_3": "Tiles-module-scss-module__o95yIq__flex_desktop_3",
  "flex_desktop_4": "Tiles-module-scss-module__o95yIq__flex_desktop_4",
  "flex_desktop_5": "Tiles-module-scss-module__o95yIq__flex_desktop_5",
  "flex_desktop_6": "Tiles-module-scss-module__o95yIq__flex_desktop_6",
  "flex_tablet_1": "Tiles-module-scss-module__o95yIq__flex_tablet_1",
  "flex_tablet_2": "Tiles-module-scss-module__o95yIq__flex_tablet_2",
  "flex_tablet_3": "Tiles-module-scss-module__o95yIq__flex_tablet_3",
  "flex_tablet_4": "Tiles-module-scss-module__o95yIq__flex_tablet_4",
  "flex_tablet_5": "Tiles-module-scss-module__o95yIq__flex_tablet_5",
  "flex_tablet_6": "Tiles-module-scss-module__o95yIq__flex_tablet_6",
});
